import usePrivateAxios from "@/common/api/usePrivateAxios";
import { BulkActionGlobalColumnsValidationSchema } from "@/common/schemas/bulkActions/globalColumns.schema";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

interface UseBulkActionsEntriesRequestTemplateProps {
  actionerKlass?: string;
  timeZone?: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

export const useBulkActionsEntriesRequestTemplate = ({
  actionerKlass,
  timeZone,
  onSuccess,
  onError,
}: UseBulkActionsEntriesRequestTemplateProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['bulkActionsEntriesRequestTemplate'],
    mutationFn: (globalColumns: BulkActionGlobalColumnsValidationSchema) => {
      const payload = {
        entry: {
          actioner_klass: actionerKlass,
          options: {
            time_zone: timeZone,
            global_columns: globalColumns,
          }
        }
      };

      return privateAxios.post('/bulk_actions/entries/request_template', payload);
    },
    onSuccess,
    onError,
  });
};
